import React, { useEffect, useState } from "react";
import Nav from "../components/navbar";
import { UserAuth } from "../context/authContext";
import {
  AiFillInstagram,
  AiFillTwitterSquare,
  AiFillLinkedin,
} from "react-icons/ai";
import { FaGithubSquare } from "react-icons/fa";
import { motion } from "framer-motion";
import { db } from "../firebase-config";
import { updateDoc, doc, getDoc } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase-config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Account() {
  const { user } = UserAuth();

  const [name, setName] = useState(user.displayName);
  const [birthdate, setBirthDate] = useState("");
  const [occupation, setOccupation] = useState("");
  const [insta, setInsta] = useState("");
  const [twitter, setTwitter] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [github, setGithub] = useState("");
  const [profile, setProfile] = useState("");
  const [bio, setBio] = useState("");

  const Upload = (e) => {
    const imgFile = e.target.files[0];
    const storageRef = ref(storage, `profIMGS/${Date.now()}-${imgFile.name}`);

    const uploadTask = uploadBytesResumable(storageRef, imgFile);

    uploadTask.on("state_changed", () => {
      getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
        setProfile(downloadURL);
      });
    });
  };

  const getUser = async () => {
    const userRef = doc(db, "users", user.uid);
    let prof = null;
    let nom = null;
    let twitt = null;
    let git = null;
    let link = null;
    let inst = null;
    let occ = null;
    let birth = null;
    let bi = null;

    await getDoc(userRef).then((snapshot) => {
      if (snapshot.data().profilePic) {
        prof = snapshot.data().profilePic;
      } else {
        prof = "";
      }

      if (snapshot.data().username) {
        nom = snapshot.data().username;
      } else {
        nom = "";
      }

      if (snapshot.data().twitterURL) {
        twitt = snapshot.data().twitterURL;
      } else {
        twitt = "";
      }

      if (snapshot.data().githubURL) {
        git = snapshot.data().githubURL;
      } else {
        git = "";
      }

      if (snapshot.data().linkedin) {
        link = snapshot.data().linkedin;
      } else {
        link = "";
      }

      if (snapshot.data().instaURL) {
        inst = snapshot.data().instaURL;
      } else {
        inst = "";
      }

      if (snapshot.data().occupation) {
        occ = snapshot.data().occupation;
      } else {
        occ = "";
      }

      if (snapshot.data().birthDate) {
        birth = snapshot.data().birthDate;
      } else {
        birth = "";
      }

      if (snapshot.data().bio) {
        bi = snapshot.data().bio;
      } else {
        bi = "";
      }
    });
    setProfile(prof);
    setName(nom);
    setTwitter(twitt);
    setGithub(git);
    setLinkedin(link);
    setInsta(inst);
    setOccupation(occ);
    setBirthDate(birth);
    setBio(bi);
  };

  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    console.log("date" + birthdate);
  }, [birthdate]);

  const handleSubmit = async () => {
    const userRefDoc = doc(db, "users", user.uid);

    var Namearray = [];
    for (let i = 1; i < name.length + 1; i++) {
      Namearray.push(name.substring(0, i).toLowerCase());
    }

    if (name.length > 0) {
      await updateDoc(userRefDoc, {
        NameAsArray: Namearray,
        profilePic: profile,
        username: name,
        birthDate: birthdate,
        occupation: occupation,
        instaURL: insta,
        twitterURL: twitter,
        githubURL: github,
        linkedin: linkedin,
        bio: bio,
      }).then(() => {
        toast.success("Changes were saved successfully!");
      });
    } else {
      toast.error("Username should be filled!");
    }
  };

  return (
    <div className="mainWrapper">
      <Nav />

      <div className="innerwrapper overflow-y-auto p-0 bgAccount flex flex-row">
        {profile && (
          <div className="w-[75%] h-full py-10 px-16">
            <motion.div
              animate={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: -30 }}
              transition={{ ease: "easeOut", duration: 0.5 }}
            >
              <div className="text-OrangyRed font-semibold text-xl">
                Account Settings
              </div>
              <div className="text-zinc-500 font-medium mt-1">
                Modify and save your profile changes
              </div>
              <div className="mb-10 w-56 h-1 mt-3 bg-[#202020] bg-opacity-30"></div>
            </motion.div>
            <motion.div
              className="w-full flex flex-col"
              animate={{ opacity: 1, scale: 1 }}
              initial={{ opacity: 0, scale: 0.95 }}
              transition={{ ease: "easeOut", duration: 0.3, delay: 0.7 }}
            >
              {/*username , birthday , occupation , instaURL , githubURL , twitterURL , linkedin */}
              <div className="flex flex-row justify-between">
                {/*username*/}
                <div className="inputContainer">
                  <label className="label" htmlFor="username">
                    <span className="label-text text-inputLabel font-bold text-sm">
                      Username
                    </span>
                  </label>
                  <input
                    defaultValue={name}
                    type="text"
                    placeholder="Type in a username..."
                    name="username"
                    className="inputStyle w-[22rem] capitalize bg-[#202020] placeholder:text-zinc-600"
                    onChange={(e) => {
                      setName(e.target.value.toLowerCase());
                    }}
                  />
                </div>
                {/*birthday*/}
                <div className="inputContainer">
                  <label className="label" htmlFor="birthdate">
                    <span className="label-text text-inputLabel font-bold text-sm">
                      Date of birth
                    </span>
                  </label>
                  <input
                    defaultValue={birthdate}
                    type="date"
                    name="birthdate"
                    className="inputStyle px-2 w-[22rem] capitalize bg-[#202020] placeholder:text-zinc-600"
                    onChange={(e) => setBirthDate(e.target.value)}
                  />
                </div>
              </div>
              <div className="flex flex-row justify-between mt-9">
                {/*occupation*/}
                <div className="inputContainer">
                  <label className="label" htmlFor="occup">
                    <span className="label-text text-inputLabel font-bold text-sm">
                      Occupation
                    </span>
                  </label>
                  <input
                    defaultValue={occupation}
                    type="text"
                    name="occup"
                    placeholder="Type in your occupation..."
                    className="inputStyle px-2 w-[22rem] capitalize bg-[#202020] placeholder:text-zinc-600"
                    onChange={(e) => setOccupation(e.target.value)}
                  />
                </div>
                <div className="inputContainer">
                  <label className="label" htmlFor="bio">
                    <span className="label-text text-inputLabel font-bold text-sm">
                      Bio
                    </span>
                  </label>
                  <input
                    defaultValue={bio}
                    type="text"
                    name="bio"
                    placeholder="Type in something about you..."
                    className="inputStyle px-2 w-[22rem] capitalize bg-[#202020] placeholder:text-zinc-600"
                    onChange={(e) => setBio(e.target.value)}
                  />
                </div>
              </div>
              <div className="flex flex-row justify-between mt-9">
                {/*insta*/}
                <div className="inputContainer">
                  <label className="label" htmlFor="insta">
                    <span className="label-text text-inputLabel font-bold text-sm">
                      Instagram url
                    </span>
                  </label>
                  <div className="flex flex-row bg-[#202020] items-center rounded-lg">
                    <input
                      defaultValue={insta}
                      type="text"
                      name="insta"
                      placeholder="Enter your instagram page url..."
                      className="inputStyle px-2 w-[19.7rem] capitalize bg-[#202020] placeholder:text-zinc-600"
                      onChange={(e) => {
                        setInsta(e.target.value);
                      }}
                    />
                    <AiFillInstagram
                      size={25}
                      className="fill-[#303030] mr-3"
                    />
                  </div>
                </div>
                {/*twitter*/}
                <div className="inputContainer">
                  <label className="label" htmlFor="twitter">
                    <span className="label-text text-inputLabel font-bold text-sm">
                      Twitter url
                    </span>
                  </label>
                  <div className="flex flex-row bg-[#202020] items-center rounded-lg">
                    <input
                      defaultValue={twitter}
                      type="text"
                      name="twitter"
                      placeholder="Enter your twitter page url..."
                      className="inputStyle px-2 w-[19.7rem] capitalize bg-[#202020] placeholder:text-zinc-600"
                      onChange={(e) => setTwitter(e.target.value)}
                    />
                    <AiFillTwitterSquare
                      size={25}
                      className="fill-[#303030] mr-3 rounded-xl"
                    />
                  </div>
                </div>
              </div>

              <div className="flex flex-row justify-between mt-9">
                {/*linkedin*/}
                <div className="inputContainer">
                  <label className="label" htmlFor="linkedin">
                    <span className="label-text text-inputLabel font-bold text-sm">
                      LinkedIn url
                    </span>
                  </label>
                  <div className="flex flex-row bg-[#202020] items-center rounded-lg">
                    <input
                      defaultValue={linkedin}
                      type="text"
                      name="linkedin"
                      placeholder="Enter your LinkedIn page url..."
                      className="inputStyle px-2 w-[19.7rem] capitalize bg-[#202020] placeholder:text-zinc-600"
                      onChange={(e) => setLinkedin(e.target.value)}
                    />
                    <AiFillLinkedin size={25} className="fill-[#303030] mr-3" />
                  </div>
                </div>
                {/*github*/}
                <div className="inputContainer">
                  <label className="label" htmlFor="github">
                    <span className="label-text text-inputLabel font-bold text-sm">
                      Github url
                    </span>
                  </label>
                  <div className="flex flex-row bg-[#202020] items-center rounded-lg">
                    <input
                      defaultValue={github}
                      type="text"
                      name="github"
                      placeholder="Enter your Github page url..."
                      className="inputStyle px-2 w-[19.7rem] capitalize bg-[#202020] placeholder:text-zinc-600"
                      onChange={(e) => setGithub(e.target.value)}
                    />
                    <FaGithubSquare size={23} className="fill-[#303030] mr-3" />
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        )}
        {profile && (
          <div className="w-[25%] h-full flex flex-col justify-between pr-16 items-center">
            <motion.div
              className="bg-[#141414] w-56 h-80 rounded-b-full flex flex-col items-center justify-between py-8"
              animate={{ opacity: 1, y: 0 }}
              initial={{ opacity: 0, y: -30 }}
              transition={{ ease: "easeOut", duration: 0.5, delay: 0.3 }}
            >
              <div className="w-36 h-36 rounded-full">
                <img
                  src={profile}
                  alt="profile"
                  referrerPolicy="no-referrer"
                  className="h-full w-full object-cover rounded-full"
                />
              </div>

              <div>
                <label
                  htmlFor="image"
                  className="bg-OrangyRed w-32 flex text-sm items-center justify-center px-3 py-2 mb-4 text-zinc-100 font-semibold rounded-lg transition hover:scale-105 ease-in-out hover:cursor-pointer"
                >
                  Upload image
                </label>
                <input
                  name="image"
                  id="image"
                  type="file"
                  accept=" image/jpeg, image/jpg"
                  className="w-0 h-0"
                  onChange={Upload}
                />
              </div>
            </motion.div>

            <button
              className="bg-OrangyRed w-fit px-3 py-2 text-zinc-100 font-semibold rounded-lg mb-11 transition hover:scale-105 ease-in-out"
              onClick={handleSubmit}
            >
              Save Changes
            </button>
          </div>
        )}
      </div>

      <ToastContainer
        position="top-center"
        theme="dark"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        closeButton={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default Account;
